import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';

import { compose } from 'redux';

import { Error as BookingError } from 'components/BookingSteps/Error';

import { resetAppointment } from '../../actions';

class Error extends React.Component {
  constructor(props) {
    super(props);

    this.goHome = this.goHome.bind(this);
  }

  goHome() {
    setTimeout(() => {
      this.props.resetAppointment();
    }, 0);
    this.props.router.push('/');
  }

  render() {
    const { appointment } = this.props;

    let errorMessage =
      'There was an error processing your booking. Please try again later.';

    if (appointment?.error) {
      if (
        appointment.error.error &&
        typeof appointment.error.error === 'string'
      ) {
        errorMessage = appointment.error.error;
      } else if (
        appointment.error.response &&
        appointment.error.response.data &&
        appointment.error.response.data.error &&
        typeof appointment.error.response.data.error === 'string'
      ) {
        errorMessage = appointment.error.response.data.error;
      }
    }

    return <BookingError errorMessage={errorMessage} onConfirm={this.goHome} />;
  }
}

export default compose(
  withRouter,
  connect(
    (state) => ({
      appointment: state.appointment,
      publicUser: state.publicUser,
      slug: state.publicUser.slug,
    }),
    (dispatch) => ({
      resetAppointment() {
        dispatch(resetAppointment());
      },
    }),
  ),
)(Error);
